export type HolidayBannerBackground = 'black-gold' | 'purple';

export type HolidayBannerTextPart = {
  text: string;
  bold?: boolean;
};

export type HolidayBannerConfig = {
  startDate: string;
  endDate: string;
  textParts: HolidayBannerTextPart[];
  background: HolidayBannerBackground;
  campaignUrl?: string;
};

/**
 * Default banner configuration (purple background)
 * Shown when no scheduled banner is active
 */
export const DEFAULT_HOLIDAY_BANNER: HolidayBannerConfig = {
  startDate: '',
  endDate: '',
  textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for Registered Customers' }],
  background: 'purple',
};

/**
 * Holiday Banner rotation schedule
 * All times are in SGT (Asia/Singapore timezone) at 3PM (15:00)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const HOLIDAY_BANNER_ROTATIONS: HolidayBannerConfig[] = [
  // Dec 3 (3PM) - Dec 5 (3PM): "Free Shipping for Registered Customers" (black-gold)
  {
    startDate: '2025-12-03 15:00:00',
    endDate: '2025-12-05 15:00:00',
    textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for Registered Customers' }],
    background: 'black-gold',
  },
  // Dec 5 (3PM) - Dec 8 (3PM): "Order now for 20% OFF and smooth holiday delivery!" (black-gold)
  {
    startDate: '2025-12-05 15:00:00',
    endDate: '2025-12-08 15:00:00',
    textParts: [{ text: 'Order now for 20% OFF', bold: true }, { text: ' and smooth holiday delivery!' }],
    background: 'black-gold',
    // TODO: Add campaign link when Christmas campaign page is ready
    // campaignUrl: '/campaign/christmas/',
  },
  // Dec 8 (3PM) - Dec 12 (3PM): "Free Shipping for Registered Customers" (black-gold)
  {
    startDate: '2025-12-08 15:00:00',
    endDate: '2025-12-12 15:00:00',
    textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for Registered Customers' }],
    background: 'black-gold',
  },
  // Dec 12 (3PM) - Dec 19 (3PM): "CHRISTMAS DEALS UP TO 20% OFF" (black-gold)
  {
    startDate: '2025-12-12 15:00:00',
    endDate: '2025-12-19 15:00:00',
    textParts: [{ text: 'CHRISTMAS DEALS UP TO 20% OFF', bold: true }],
    background: 'black-gold',
    // TODO: Add campaign link when Christmas campaign page is ready
    // campaignUrl: '/campaign/christmas/',
  },
  // Dec 19 (3PM) - Dec 26 (3PM): "CHRISTMAS DEALS UP TO 50% OFF" (black-gold)
  {
    startDate: '2025-12-19 15:00:00',
    endDate: '2025-12-26 15:00:00',
    textParts: [{ text: 'CHRISTMAS DEALS UP TO 50% OFF', bold: true }],
    background: 'black-gold',
    // TODO: Add campaign link when Christmas campaign page is ready
    // campaignUrl: '/campaign/christmas/',
  },
  // Dec 26 (3PM) - Jan 2 (3PM): "NEW YEAR DEALS UP TO 50% OFF" (black-gold)
  {
    startDate: '2025-12-26 15:00:00',
    endDate: '2026-01-02 15:00:00',
    textParts: [{ text: 'NEW YEAR DEALS UP TO 50% OFF', bold: true }],
    background: 'black-gold',
    // TODO: Add campaign link when New Year campaign page is ready
    // campaignUrl: '/campaign/new-year/',
  },
];

export const HOLIDAY_BANNER_TIMEZONE = 'Asia/Singapore';
